import { DRAFT } from '@constants/documents.constants';
import { AnySendingSearchParams, ParsedSearchParams, PatientSearch } from '@domain/types';
import { DEFAULT_DASHBOARD_DATE_RANGE_DAYS } from '@filters';
import { addDays, format } from 'date-fns';

export const defaultDateRangeRule = addDays(new Date(), -Number(DEFAULT_DASHBOARD_DATE_RANGE_DAYS));

export function searchParamsToParsedSearchParams(
  searchParams: AnySendingSearchParams,
): ParsedSearchParams {
  const parsedSearchParams = { ...searchParams };
  const cleanoutList = ['defaultDateRange', 'dateRange', 'searchPatient']; // use constants instead (see ParsedSearchParams type)

  return Object.fromEntries(
    Object.entries(parsedSearchParams).reduce(
      (acc, [key, val]) => {
        if (!cleanoutList.includes(key)) {
          acc.push([key, val]);
        }
        return acc;
      },
      [] as [string, any][],
    ),
  );
}

export const parseSearchParams = (searchParams: AnySendingSearchParams): ParsedSearchParams => {
  const parsedSearchParams = searchParamsToParsedSearchParams(searchParams);

  if (searchParams.defaultDateRange) {
    parsedSearchParams.fromDate = defaultDateRangeRule;
  } else if (searchParams.dateRange) {
    parsedSearchParams.fromDate = searchParams.dateRange.fromDate;
    parsedSearchParams.untilDate = searchParams.dateRange.untilDate;
  }

  if (searchParams.searchPatient) {
    Object.entries(searchParams.searchPatient).forEach(([key, val]) => {
      const newkey = `patientSearch[${key}]` as keyof ParsedSearchParams;

      parsedSearchParams[newkey] = val;
    });
  }
  return Object.entries(parsedSearchParams).reduce<Record<string, any>>((params, [key, val]) => {
    if (val !== undefined) {
      if (val instanceof Date) {
        params[key] = format(val, 'yyyy-MM-dd');
      } else {
        params[key] = val;
      }
    }

    return params;
  }, {}); // we could also filter '' here (done in getSearchparams)
};

export function cleanFFSearchParams<T extends AnySendingSearchParams>({
  searchParams,
  dashboardType,
  currentIdentity,
}: {
  searchParams: T;
  dashboardType: string;
  currentIdentity?: string;
}): T {
  const cleanedParams = { ...searchParams };

  if (dashboardType === DRAFT && currentIdentity) {
    cleanedParams.selectedSenderFilter = undefined;
    cleanedParams.strictSender = currentIdentity;
  }

  return cleanedParams;
}

export function searchPatientToParamList(searchPatient: PatientSearch): string[] {
  return Object.keys(searchPatient).map((param) => param);
}
